import type { Theme } from '@mui/material';

export const styles = {
  root: (theme: Theme) => ({
    borderRadius: '0.5rem 0.5rem 0 0 !important',
    background: theme.palette.primary.main,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '18.75rem',
    },
  }),

  accordionContainer: () => ({
    height: '20.75rem',
    overflow: 'auto',
  }),

  summary: (theme: Theme) => ({
    color: theme.palette.common.white,
    display: 'flex',
    height: '4.5rem',

    [theme.breakpoints.up('sm')]: {
      height: '3rem',
    },

    '&.Mui-expanded': {
      minHeight: '4.5rem',
      [theme.breakpoints.up('sm')]: {
        minHeight: '3rem',
      },
    },

    '& .Mui-expanded': {
      marginTop: theme.spacing(1.5),
      marginBottom: theme.spacing(1.5),
    },
  }),

  summaryArrow: (theme: Theme) => ({
    color: theme.palette.common.white,
  }),

  details: (theme: Theme) => ({
    background: theme.palette.common.white,
    paddingTop: theme.spacing(1.5),
    paddingX: theme.spacing(1),
    minHeight: theme.spacing(40),
    display: 'flex',
    flexDirection: 'column',
  }),

  endButton: () => ({
    marginTop: 'auto',
  }),

  bouncingArrowButton: (theme: Theme) => ({
    borderRadius: '100%',
    background: theme.palette.primary.main,
    width: theme.spacing(8),
    height: theme.spacing(8),
    position: 'relative',
    marginBottom: theme.spacing(4),
    marginLeft: theme.spacing(4),
  }),

  bouncingArrowCircle: (theme: Theme) => ({
    borderRadius: '100%',
    borderWidth: 2,
    borderStyle: 'solid',
    borderColor: theme.palette.common.white,
    width: theme.spacing(6),
    height: theme.spacing(6),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
  }),

  bouncingArrow: () => ({
    '@keyframes bouncing': {
      '0%': {
        marginTop: -0.5,
      },
      '50%': {
        marginTop: 0.5,
      },
      '100%': {
        marginTop: -0.5,
      },
    },
    fontSize: '2rem',
    marginTop: -1,
    animation: 'bouncing 1s ease infinite',
  }),

  notification: {
    '&.MuiSnackbar-root': {
      marginTop: 0,
    },
  },

  notificationContent: (theme: Theme) => ({
    bgcolor: theme.colors.white,
    color: theme.colors.black,
    flexWrap: 'nowrap',

    '&.MuiPaper-root': {
      padding: '1rem 1.5rem',
    },

    '> *': {
      p: 0,
    },
  }),

  notificationIcon: (theme: Theme) => ({
    borderRadius: '50%',
    bgcolor: theme.colors.error[500],
    width: '2.5rem',
    height: '2.5rem',
    color: theme.colors.white,
    justifyContent: 'center',
    flexDirection: 'column',

    svg: {
      margin: 'auto',
    },
  }),

  notificationText: {
    direction: 'column',
    justifyContent: 'center',
    px: 2.5,
    maxWidth: '22rem',
  },
};
